export default {"src":"/_next/static/media/gxs.23dddbdd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};